import * as React from "react"
import {FromatNumberVIE} from '../../../utils/format'
import Tag from "../Tag";
import Tooltip from '../ToolTip';
import { navigate } from 'gatsby';

import "./Properties.css"

const PropertiesHotdeal = ({item, tag=""}) =>{
    const handleRedirect=(uri)=>{
        window.localStorage.setItem('typepage', 'product');
        navigate(uri);
      }
    return(
    <div  className="right-block">
        <div  className="caption">
            {/* <h1 className="d-none">{item?.name}</h1> */}
            <h4 ><a href={item.linksp !== '/undefined' ? ('/' + item.linksp?.replace('/', '')) : ("#")} onClick={() => handleRedirect('/'+item?.linksp.replace('/',''))} title={item?.name}>
                    {
                    item?.name?.length > 55 ? ( (item?.name).substring(0, 55) +'...') :(item?.name)
                    }
                </a></h4>
                {
                    tag !==""?(<Tag key="HotDeal" tag={tag} classTag="hotdeal"/>):(null)
                }
            <div  className="price mgt-5">
                {
                    +item?.price['discount'] === +item?.price['raw'] ? (
                    <span  className="price-new">{FromatNumberVIE(item?.price['raw'])}đ</span>
                    ) : (
                        <div className="mgt-5">
                            <span  className="price-new">{FromatNumberVIE(item?.price['discount'])}đ</span>
                            <span  className="price-old">{FromatNumberVIE(item?.price['raw'])}đ</span>
                        </div>
                    )
                }
            </div>
            <Tooltip key="tooltip" total={item?.hotdeal?.total}  quantity ={item?.hotdeal?.quantity}/>
        </div>
    </div>
)
};

const PropertiesProduct = ({item, tag=""}) =>{
    // const handleRedirect=(uri)=>{
    //     window.localStorage.setItem('typepage', 'product');
    //     navigate('/'+uri.linksp.replace('/',''));
    //   }
    if(item.typePromotion &&  +item.typePromotion  !== 1 && item.parent){
        item.linksp = item.parent.linksp;
    }
    if(item?.name){
    return(
    <div  className="right-block">
        <div  className="caption">
        {/* <h1 className="d-none">{item?.name}</h1> */}
            <h4 ><a href={item.linksp ? ('/' + item.linksp?.replace('/', '')):(null)} title={item?.name}>
            {
            item?.name?.length > 50 ? ( (item?.name).substring(0, 50) +'...') :(item?.name)
            }
            </a></h4>
            {
               tag !== "" ? (<Tag key={tag} tag={tag} classTag="gifts"/>):(null)
            }
            {
                item?.namePromotion && item?.namePromotion !== 'Mua là có quà' ? (<Tag key={item?.namePromotion} tag={item?.namePromotion} classTag="gifts"/>):(null)
            }
            <div  className="price mgt-5">
            {
                +item?.price['discount'] === +item?.price['raw'] ? (
                <span  className="price-new">{FromatNumberVIE(item?.price['raw'])}đ</span>
                ) : (
                    <div className="mgt-5">
                        <span  className="price-new">{FromatNumberVIE(item?.price['discount'])}đ</span>
                        <span  className="price-old">{FromatNumberVIE(item?.price['raw'])}đ</span>
                    </div>
                )
                }
            </div>
        </div>
    </div>
)
}else{
    return null;
}
};

export {PropertiesHotdeal, PropertiesProduct};